const CREDIT_WARNING = /\b(?:insufficient|not enough|out of|ran out of|no)\s+(?:available\s+)?credits?\b/i;
const CREDIT_BLOCK = /\bcredit[- ](?:blocked|shortfall)\b|\bcredits?\s+(?:are\s+|is\s+)?(?:depleted|exhausted)\b/i;

/** Persisted credit warnings can predate structured gate metadata; rewards are not warnings. */
export const isCreditBlockedMessage = (content: string): boolean => (
  CREDIT_WARNING.test(content) || CREDIT_BLOCK.test(content)
);
